// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/execution-plans/BusinessImpactCard.jsx

import React from "react";
import { ExecutionPlanSection, EmptyPanel, MetricTile, bodyTextStyle, displayValue } from "./ExecutionSummaryCard";

export default function BusinessImpactCard({ impact }) {
  if (!impact) {
    return <EmptyPanel title="No business impact forecast" message="Business impact forecasting was not returned for this task yet." />;
  }

  return (
    <ExecutionPlanSection eyebrow="Forecast" title="Business impact forecast" badge={impact.business_impact || "review"}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 12 }}>
        <MetricTile label="Posture" value={impact.expected_posture_improvement} />
        <MetricTile label="Risk Reduction" value={impact.risk_reduction} />
        <MetricTile label="Executive Visibility" value={impact.executive_visibility} />
        <MetricTile label="Validation" value={impact.validation_confidence} />
      </div>
      <p style={{ ...bodyTextStyle, marginTop: 14 }}>{displayValue(impact.expected_outcome, "Expected outcome pending.")}</p>
      {Array.isArray(impact.affected_controls) && impact.affected_controls.length ? (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
          {impact.affected_controls.map((control, index) => (
            <span key={`${control}-${index}`} style={{ border: "1px solid rgba(148, 163, 184, 0.18)", borderRadius: 999, color: "#dbeafe", padding: "6px 10px", fontSize: 11, fontWeight: 850 }}>
              {displayValue(control)}
            </span>
          ))}
        </div>
      ) : null}
    </ExecutionPlanSection>
  );
}
